import * as React from 'react';
import { observer } from 'mobx-react-lite';

interface FCProps {}

const Hero: React.FC<FCProps> = observer(({}) => {
  return null;
});

export default Hero;
